/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC,  useState } from 'react'
import { useAuth } from '../../../../app/modules/auth'
import { ResetPasswordModal } from '../../../../app/pages/dashboard/_modals/Futurisk/ResetPasswordModal'
import { toAbsoluteUrl } from '../../../helpers'


const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth()
  const [modalShow, setModalShow] = useState(false);

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/futuriskicon/ms-icon-150x150.png')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.Name}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'></span>
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>

            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a onClick={()=>{setModalShow(true)}} className='menu-link px-5'>
          Change Password
        </a>
        <ResetPasswordModal show={modalShow} handleClose={() => { setModalShow(false) }} />
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
